<template lang="pug">
  h3.text-18.md-text-24.text-center.mb-30.md-mb-50(:class="index > 0 ? 'mt-120 md-mt-164' : 'mt-53'")
    wp-link(v-if="row.link", :link="row.link") {{row.header}}
    span(v-else, v-html="row.header")
</template>

<script>
import wpLink from '@/components/WPLink'
export default {
  name: 'Flx__Header',
  props: ['row', 'index'],
  components: { wpLink }
}
</script>

<style>
</style>
